import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { IFavoriteItem } from '../../../../models/IFavoriteItem';
import { CommonModule } from '@angular/common';
// import { InputSwitchModule } from 'primeng/inputswitch';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TimeLeftService } from '../../../../services/time-left.service';
import { SanitizeHtmlTextPipe } from '../../../../shared/pipes/sanitize-html-text.pipe';
import { FavoritesItemsService } from '../../../../services/favorites/favorites-items.service';
import { RouterModule } from '@angular/router';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-favorites-page',
  imports: [CommonModule,
    // InputSwitchModule,
    ToggleSwitch,
    FontAwesomeModule,
    ButtonModule,
    FormsModule,
    SanitizeHtmlTextPipe,
    RouterModule],
  templateUrl: './favorites-page.component.html',
  styleUrl: './favorites-page.component.scss'
})
export class FavoritesPageComponent implements OnInit {

  faCrown = faCrown;
  faTrashCan = faTrashCan;

  @Input() items: IFavoriteItem[] = [];
  @Output() removedFavorite = new EventEmitter<number>();

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private readonly sanitizer = inject(DomSanitizer);
  protected readonly timeLeftService = inject(TimeLeftService);
  protected readonly favoriteService = inject(FavoritesItemsService);
  protected readonly confirmationService = inject(ConfirmationService);


  ngOnInit(): void {
    // console.log(this.items)
  }

  trackById(index: number, item: IFavoriteItem): number {
    return item.itemId;
  }

  onConfirmRemove(itemId: number, hasBid: boolean) {
    if (hasBid) {
      this.confirmationService.confirm({
        header: 'Remove from Favorites?',
        message:
          `
  This will only remove the item from your Favorites.<br>
  <strong> It will not cancel your bid(s)</strong> on this item.<br>
  To retract a bid, follow <a href="https://support.frontstream.com/hc/en-us/articles/115005896266-Bidders-How-to-Request-a-Bid-Retraction" target="_blank" class="cursor-pointer ">these steps</a>.
`,
        accept: () => {
          this.removeItemFavorite(itemId);
        },
        reject: () => {
        }
      });
    } else {
      this.removeItemFavorite(itemId);
    }
  }

  removeItemFavorite(itemId: number) {

    this.favoriteService.deleteFavorite(itemId).subscribe({
      next: (response) => {
        // console.log(response);
        this.removedFavorite.emit(itemId);

      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }


  onPutEmailAddress(itemId: number, value: boolean) {
    this.favoriteService.putEmailAddress(itemId, value).subscribe({
      next: (response) => {
        // console.log(response);
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }


}
